import {
  defaultEdgeLabelsOptions,
  defaultEdgeThicknessThresholds,
} from './GraphPreset';
import type {
  TopologyGraphPreset,
  TopologyGraphSettings,
} from './TopologyGraphPreset';

export const factoryPresetEdges = {
  layer1: 'c406f1d0-3ec5-4469-8449-a3265e55fe38',
  layer2: '7ad7117a-2095-4467-9160-8e07812ee27a',
  layer3: '541b21e2-a1ff-4008-a507-058650949d43',

  dgw: 'a006f981-1dcb-402b-809a-7f3987698c2c',
  dgwIpv6: 'd296e46f-b29b-41ae-9993-4a2be5aaa59f',
  ebgp: '22fcfee9-a5d6-4bc2-9571-cd0723f614ba',
  eigrp: 'a8cfe167-9d5b-46d6-926b-64fd0e6614f1',
  fex: '324e2957-a552-4ff8-bf1b-62636579d684',
  ibgp: 'cda608e0-e799-4596-81a3-359ab1905726',
  ipsec: '15265cc1-e36b-4609-a91f-a9f609235bc0',
  isis: 'bfc36b1e-40ec-4a6c-a1ff-2806cdd6e515',
  ldp: '25552872-e891-4a7d-9991-7c916373a72e',
  manualLinkL1: 'c7ea0277-50af-49e7-a0fd-2f22fb1e0ad5',
  manualLinkL2: 'dbe95a43-209f-4a1f-bac7-2234cab20248',
  sdWan: 'f4a7c6e1-8b3d-4f2a-9e5c-1d6a8b3c7f90',
  cloudGroup: 'cf3e8d2a-b4f1-4a9c-8e7b-5d2f6c1a3e90',
  cloudPeering: 'd2e9f1a3-c5b6-4d8e-9f0a-1b2c3d4e5f6a',
  cloudGateway: 'e3f0a2b4-d6c7-4e9f-0a1b-2c3d4e5f6a7b',
  ospf: '28d798fa-d371-4fd2-bdab-03abfe27534b',
  ospfv3: '790ff6f8-7952-4f6b-bf8c-5bb56e81ba1b',
  pim: '8cf5dd10-99ed-401c-bfe9-ed00f06cc88f',
  rib: '39502c84-49af-49ad-8fb2-7e15a070dabf',
  ribIpv6: 'eac26b3c-8275-49e2-9ab4-245f2fcf0a88',
  rip: 'cdd7703b-6a76-4e22-84ae-3b43896345c0',
  rsvp: 'd8696d39-bc3b-478e-acbf-97aba190a60e',
  stp: '63cf94a0-2aaa-4ef2-879e-1c36996deac9',
  vxlan: 'bc272c5d-ab69-43c3-bb98-da52ff42058a',
  wired: '798834a5-800b-4c61-91d0-ed14b0cb1d53',
  wireless: 'f6826c13-f6c1-499e-939c-6f8fbd8efdf3',
  xdp: '24fdfa91-ab4e-4c8e-b29c-3951ee922635',
};

export const FactoryGraphSettings: TopologyGraphSettings = {
  edges: [
    {
      id: factoryPresetEdges.layer1,
      name: 'Layer 1',
      type: 'group',
      label: 'L1',
      grouped: true,
      style: {
        color: '#6fb96f',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      children: [
        {
          id: factoryPresetEdges.xdp,
          name: 'xdp',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#66ff66',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.fex,
          name: 'fex',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#a0a0a0',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.wired,
          name: 'wired',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#be93ff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.wireless,
          name: 'wireless',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#be93ff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.manualLinkL1,
          name: 'manualLinkL1',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#33e2c4',
            pattern: 'dashed',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
      ],
      visible: true,
      labelsOptions: defaultEdgeLabelsOptions,
    },
    {
      id: factoryPresetEdges.layer2,
      name: 'Layer 2',
      type: 'group',
      label: 'L2',
      grouped: true,
      style: {
        color: '#7aa3cc',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      children: [
        {
          id: factoryPresetEdges.stp,
          name: 'stp',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#99ccff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.manualLinkL2,
          name: 'manualLinkL2',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#33e2c4',
            pattern: 'dashed',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
      ],
      visible: true,
      labelsOptions: defaultEdgeLabelsOptions,
    },
    {
      id: factoryPresetEdges.layer3,
      name: 'Layer 3',
      type: 'group',
      label: 'L3',
      grouped: true,
      style: {
        color: '#b77acc',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      children: [
        {
          id: factoryPresetEdges.rib,
          name: 'rib',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#ff99ff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.ribIpv6,
          name: 'ribIpv6',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#ff99ff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.dgw,
          name: 'dgw',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#ff99ff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.dgwIpv6,
          name: 'dgwIpv6',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#ff99ff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.ebgp,
          name: 'ebgp',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#009688',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'as'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.ibgp,
          name: 'ibgp',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#009688',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'as'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.ospf,
          name: 'ospf',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#ffd600',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.ospfv3,
          name: 'ospfv3',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#ffd600',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.eigrp,
          name: 'eigrp',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#00bcd4',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.ldp,
          name: 'ldp',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#ff9800',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.pim,
          name: 'pim',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#9d744d',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.rip,
          name: 'rip',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#a1887f',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.isis,
          name: 'isis',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#cddc39',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.vxlan,
          name: 'vxlan',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#ff9999',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.rsvp,
          name: 'rsvp',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#2693ff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.ipsec,
          name: 'ipsec',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#e926ff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.sdWan,
          name: 'sd-wan',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#d4b524',
            pattern: 'dashed',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol', 'intName'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
      ],
      visible: true,
      labelsOptions: defaultEdgeLabelsOptions,
    },
    {
      id: factoryPresetEdges.cloudGroup,
      name: 'Cloud',
      type: 'group',
      label: 'Cloud',
      grouped: true,
      style: {
        color: '#4db8ff',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      children: [
        {
          id: factoryPresetEdges.cloudPeering,
          name: 'cloud-peering',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#4db8ff',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
        {
          id: factoryPresetEdges.cloudGateway,
          name: 'cloud-gateway',
          type: 'protocol',
          grouped: true,
          style: {
            color: '#0288d1',
            pattern: 'solid',
            thicknessThresholds: defaultEdgeThicknessThresholds,
          },
          visible: true,
          labels: ['protocol'],
          labelsOptions: defaultEdgeLabelsOptions,
        },
      ],
      visible: true,
      labelsOptions: defaultEdgeLabelsOptions,
    },
  ],
  hiddenDeviceTypes: ['ap', 'fex', 'host', 'phone'],
};

export const FactoryPreset: TopologyGraphPreset = {
  ...FactoryGraphSettings,
  id: '3964b4a1-71a5-456b-959a-68da4ee051e0',
  name: 'System',
  factory: true,
};
